// linkDeliveryToRun — the ONE insert that puts a delivery on a run.
//
// Runs' "Add another delivery" and the "Put on a run" sheet both call this, so
// there is no second copy of the write. A duplicate (23505: the pair is
// already linked) is not an error: the delivery IS on the run, so say so.
import type { QueryClient } from '@tanstack/react-query'
import { withTimeout } from '@/lib/saveTimeout'
import { throwFriendly } from '@/lib/friendlyError'

type Db = { from: (table: string) => any }

export interface LinkResult { alreadyLinked: boolean }

export async function linkDeliveryToRun(db: Db, runId: string, deliveryId: string): Promise<LinkResult> {
  const { error } = await withTimeout(
    db.from('run_deliveries').insert({ run_id: runId, delivery_id: deliveryId }) as PromiseLike<{ error: { code?: string; message: string } | null }>,
    'Runs: run_deliveries insert',
  )
  if (!error) return { alreadyLinked: false }
  if (error.code === '23505') return { alreadyLinked: true }
  return throwFriendly(error)
}

/** Every read a new link changes: the board chip, the delivery page, the run. */
export function invalidateAfterLink(qc: QueryClient, runId: string, deliveryId: string): void {
  const keys: unknown[][] = [
    ['run-tipping', runId],
    ['ready-to-tip'],
    ['run-linked-deliveries', runId],
    ['add-delivery-candidates', runId],
    ['deliveries-run-allocations'],
    ['delivery-linked-runs', deliveryId],
    ['delivery-runs', deliveryId],
    ['open-runs-for-delivery', deliveryId],
    ['yard-run-allocations'],
  ]
  for (const queryKey of keys) qc.invalidateQueries({ queryKey })
}
